import { BasicItem, Project, ReportingItem } from "product-test-types";

import { STRAPI_URL } from "../env";

export async function updateBasicItem(
  id: number | string | undefined,
  basicItem: BasicItem,
  projectId?: string | undefined
) {
  try {
    const response = await fetch(`${STRAPI_URL}/basic-item/${String(id)}`, {
      body: JSON.stringify({
        basicItem,
        projectId,
      }),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      method: "PUT",
    });

    if (!response.ok) {
      throw new Error(
        `update basic-item failed with status ${response.status}.`
      );
    }
  } catch {
    return undefined;
  }
}

export async function createBasicItem(
  basicItem: BasicItem,
  projectId: string | undefined,
  reportingItem?: Pick<ReportingItem, "degreeOfCompletion">
): Promise<BasicItem | undefined> {
  if (!projectId) return undefined;
  try {
    const response = await fetch(`${STRAPI_URL}/basic-item`, {
      body: JSON.stringify({
        basicItem,
        projectId,
        reportingItem,
      }),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
    });

    if (!response.ok) {
      throw new Error(`save basic-item failed with status ${response.status}.`);
    }
    const json = (await response.json()) as Project;
    return json;
  } catch {
    return undefined;
  }
}

export async function deleteBasicItem(
  id: number | string | undefined
): Promise<void> {
  try {
    const response = await fetch(`${STRAPI_URL}/basic-item/${String(id)}`, {
      credentials: "include",
      method: "DELETE",
    });

    if (!response.ok) {
      throw new Error(
        `delete basic-item failed with status ${response.status}.`
      );
    }
  } catch {
    return;
  }
}
